import format from 'date-fns/format'
import filters from './filters'
/**
 * @param {string} path
 * @returns {Boolean}
 */
const dateTimeSFormatter = function(date) {
  return format(date, 'yyyy-MM-dd HH:mm:ss')
}
const fileDateFormatter = function(row, column, cellValue, index) {
  return dateTimeSFormatter(new Date(cellValue * 1000))
}
const colors = ['white', 'green', 'red', 'white', 'green', 'white', 'green', 'red']
const fileStatusStyle = function(cellValue) {
  return { color: colors[cellValue] }
}
const fileStatusRenderer = function(row, column, cellValue, index) {
  return filters['fileStatus2Txt'](cellValue)
}
export default {
  dateTimeSFormatter: dateTimeSFormatter,
  fileDateFormatter: fileDateFormatter,
  fileStatusRenderer: fileStatusRenderer,
  fileStatusStyle: fileStatusStyle
}
